import React from "react";
import { Link } from "react-router-dom";
// ✅ Perbaiki import ikon dari react-icons
import { 
    FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaTiktok, 
    FaWhatsapp, FaEnvelope, FaMapMarkerAlt, // Font Awesome Icons
    FaShopify // Opsi untuk ikon belanja jika tidak ada yang lebih spesifik
} from "react-icons/fa"; 
import { BsShop, BsFillBagFill } from "react-icons/bs"; // ✅ Import dari 'react-icons/bs' - sering ada ikon belanja di sini

// Jika ikon spesifik seperti SiShopee atau SiTokopedia TIDAK ADA di react-icons,
// kita akan gunakan ikon generik yang relevan atau cari di sub-library lain
// Atau gunakan gambar SVG custom jika desain Anda sangat spesifik.
// Untuk tujuan ini, saya akan mencoba BsShop atau BsFillBagFill sebagai alternatif
// jika SiShopee atau SiTokopedia tidak ditemukan.

import "../styles/Footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Bagian Informasi Utama Perusahaan */}
                <div className="footer-section footer-info">
                    <h3>Depot Air Cerdas</h3>
                    <p>Solusi IoT pintar untuk pengelolaan depot air minum yang efisien, transparan, dan anti-curang.</p>
                    <p className="company-tagline">Dikembangkan oleh <strong>PT Solusi Pemetaan Pasti</strong></p>
                    <div className="contact-details">
                        <p><FaMapMarkerAlt /> Jl Swadaya 1, Mekarsari, Cimanggis, Depok, Jawa Barat</p>
                        <p><FaEnvelope /> iotdepotaircerdas@gmail.com</p>
                        <p><FaWhatsapp /> 0877-2885-0534</p>
                    </div>
                </div>

                {/* Navigasi Cepat */}
                <div className="footer-section footer-links">
                    <h4>Navigasi Cepat</h4>
                    <ul>
                        <li><Link to="/">Beranda</Link></li>
                        <li><Link to="/#features">Fitur</Link></li>
                        <li><Link to="/#workflow">Cara Kerja</Link></li>
                        <li><Link to="/login">Login</Link></li> {/* Mengarah ke halaman login */}
                        <li><Link to="/register">Daftar</Link></li> {/* Mengarah ke halaman daftar */}
                    </ul>
                </div>

                {/* Artikel Terbaru (Blog) */}
                <div className="footer-section footer-blog">
                    <h4>Baca Lebih Lanjut</h4>
                    <ul>
                        <li><Link to="/iot-manfaat">Manfaat Internet of Things (IoT)</Link></li>
                        <li><Link to="/data-science-bisnis">Data Science untuk Bisnis</Link></li>
                        <li><Link to="/keamanan-iot">Keamanan Data dalam IoT</Link></li>
                        <li><Link to="/tips-depot-teknologi">Tips Mengelola Depot dengan Teknologi</Link></li>
                        <li><Link to="/sebaran-depot">Peta Sebaran Depot Air Minum</Link></li>
                    </ul>
                </div>

                {/* Sosial Media & E-commerce */}
                <div className="footer-section footer-social">
                    <h4>Ikuti & Belanja Kami</h4>
                    <div className="social-icons">
                        <a href="https://www.instagram.com/depotaircerdas/" target="_blank" rel="noopener noreferrer" aria-label="Ikuti kami di Instagram">
                            <FaInstagram />
                        </a>
                        <a href="https://www.tiktok.com/@depot.air.cerdas" target="_blank" rel="noopener noreferrer" aria-label="Ikuti kami di TikTok">
                            <FaTiktok />
                        </a>
                        {/* ✅ Gunakan ikon generik jika SiTokopedia tidak ada. BsShop atau BsFillBagFill bisa jadi alternatif */}
                        <a href="https://www.tokopedia.com/solusi-iot-cerdas" target="_blank" rel="noopener noreferrer" aria-label="Belanja di Tokopedia">
                            <BsShop /> {/* Menggunakan ikon toko dari Bootstrap Icons */}
                        </a>
                        <a href="https://shopee.co.id/solusiiotcerdas" target="_blank" rel="noopener noreferrer" aria-label="Belanja di Shopee">
                            <BsFillBagFill /> {/* Menggunakan ikon tas belanja dari Bootstrap Icons */}
                        </a>
                    </div>
                </div>
            </div>

            {/* Copyright */}
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Depot Air Cerdas. Semua Hak Dilindungi Undang-Undang.</p>
                <p className="developer-info">Dikembangkan oleh <a href="https://www.solusipemetaanpasti.com" target="_blank" rel="noopener noreferrer">PT Solusi Pemetaan Pasti</a></p>
            </div>
        </footer>
    );
};

export default Footer;